import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row } from "reactstrap";
import backArrow from "../../../assets/icons/left-arrow.svg";

import "./BackArrow.scss";

const BackArrow = () => {
  const linkTitle = "HOME";

  const routePath = "/";

  return (
    <Row className="container">
      <Link to={routePath} className="desktop-back-container">
        <img
          alt=""
          src={backArrow}
          height={14}
          width={14}
          className="desktop-back-arrow"
        />
        <span className="desktop-back-link">{linkTitle}</span>
      </Link>
    </Row>
  );
};

export { BackArrow };
